import { KioskConnectivityStatusUpdate } from '@groundfloor-platform/types-event-grid-events';
import { SubscriptionMatcher, SubscriptionCallback } from '../signalR.eventCentre';

export const KioskConnectivitySignalRAttributeName = 'kioskConnectivity' as const;

export type KioskConnectivitySubscriptionCallback = SubscriptionCallback<KioskConnectivityStatusUpdate>;

export type KioskConnectivitySubscriptionMatcher = SubscriptionMatcher<KioskConnectivityStatusUpdate>;

export interface KioskConnectivitySubscriptionStream extends Record<string, string[]> {
  iotHubIDs: string[];
}
